
$(document).ready(function(){
    $('#receptionDataTableBuilder').DataTable({
        responsive: true,
        ordering: false,
        paging: false,
        searching:false,
        info: false,
    });
    $('#validationDataTableBuilder').DataTable({
        responsive: true,
        ordering: false,
        paging: false,
        searching:false,
        info: false,
    } );
    $('#lignesDataTableBuilder').DataTable({
        responsive: true,
        ordering: false,
        paging: false,
        searching:false,
        info: false,
    } );
    $('#billingDataTableBuilder').DataTable({
        responsive: true,
        ordering: false,
        paging: false,
        searching:false,
        info: false,
    } );
    
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        $($.fn.dataTable.tables(true)).DataTable()
           .columns.adjust()
           .responsive.recalc();
    }); 

    //delete the localStorage key of the datatables when applying filters (easiest way)
    $('#filter-button').on('click', function(e) {
        let urlPath = $(location).attr('pathname');
        localStorage.removeItem(`DataTables_dataTableBuilder_${urlPath}`);
    });

    //to make tooltip work
    $('#dataTableBuilder').on('draw.dt', function () {
        $('body').tooltip({selector: '[data-toggle="tooltip"]'});
    });
});
